import type { ReactNode } from 'react';
import type { AbstractSingleFilterPillsProps } from './SingleFilterType';
import type { FilterMetadata } from '../../../domains/global-filters/model/FilterChain';
import type {
  LargeListFilterValue,
  BasicListOption,
} from './GenericBloc/GenericLargeListFilter/GenericLargeListType';
import { GenericLargeListFilter } from './GenericBloc/GenericLargeListFilter/GenericLargeListFilter';

interface LargeListFilterProps<T> extends AbstractSingleFilterPillsProps<LargeListFilterValue<T>> {
  optionList?: readonly BasicListOption<T>[];
  optionListIsLoading?: boolean;
  isFunnelStep?: boolean;
}

export function LargeListFilterFactory<T extends string>(
  metadata: FilterMetadata,
  placeholder?: string,
  header?: ReactNode,
) {
  return ({
    currentValue,
    autoFocus,
    onApply,
    onRemove,
    onDropdownHidden,
    onDropdownShown,
    optionList = [],
    showDropdownOnMount,
    optionListIsLoading = false,
    isFunnelStep,
  }: LargeListFilterProps<T>): JSX.Element => {
    return (
      <GenericLargeListFilter<T>
        autoFocus={autoFocus}
        filterName={metadata.filterName}
        iconName={metadata.iconName}
        currentValue={currentValue}
        onApply={onApply}
        onRemove={onRemove}
        optionList={optionList}
        optionListIsLoading={optionListIsLoading}
        onDropdownHidden={onDropdownHidden}
        onDropdownShown={onDropdownShown}
        showDropdownOnMount={showDropdownOnMount}
        header={header}
        placeholder={placeholder}
        isFunnelStep={isFunnelStep}
      />
    );
  };
}
